import { useQuery } from "@tanstack/react-query";
import { getDietaryReports } from "../api/dietary-report.api";

export const dietKeys = {
  all: ["admin-member-diet-reports"] as const,
  list: (memberId: number) => 
  [...dietKeys.all, "list", memberId] as const,
};

export const useDietaryReports = (memberId: number) => {
  return useQuery({
    queryKey: dietKeys.list(memberId),
    queryFn: () => getDietaryReports(memberId),
    enabled: !!memberId,
    refetchInterval: 10000,
    select: (data) =>
      [...data].sort(
        (a, b) =>
          new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
      ),
    staleTime: 60 * 1000 * 5, // 5 mintes
    gcTime: 60 * 60 * 1000, // 1 hour
  });
};